import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Form, Typography, Table, Button, Input, Icon, Spin, Modal, notification } from 'antd';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { green } from '@material-ui/core/colors';
import Highlighter from 'react-highlight-words';
import { withTranslation } from 'react-i18next';
import adminI18n from '../../i18n/adminI18n';
import 'antd/dist/antd.css';

const { Title } = Typography;

@inject(
    'BookingItemStore'
)
@observer
class BookingItemListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: '',
            searchedColumn: ''
        }
    }

    componentDidMount() {
        this.props.BookingItemStore.initBookingItem();
    }

    // ON CLICK

    createBookingItemOnClick = () => {
        this.props.BookingItemStore.initCreateBookingItem();
    }

    updateBookingItemOnClick = (bookingItemId) => {
        this.props.BookingItemStore.initUpdateBookingItem(bookingItemId);
    }

    deleteBookingItemOnClick = (bookingItemId) => {
        const { t } = this.props;
        Modal.confirm({
            title: t('Delete Booking Item'),
            content: t('Are you sure to delete this item?'),
            okText: t('Yes'),
            cancelText: t('Cancel'),
            onOk: () => { this.deleteUpdateBookingItemOnOk(bookingItemId); }
        });
    }

    // ON OK

    deleteUpdateBookingItemOnOk = (bookingItemId) => {
        const { t } = this.props;
        this.props.BookingItemStore.deleteUpdateBookingItem(bookingItemId).then(response => {
            if (response.isSuccess) {
                notification['success']({
                    message: t('Success'),
                    description: t('Booking Item has been successfully deleted.'),
                    duration: 3
                });
            } else {
                notification['error']({
                    message: t('Error'),
                    description: response.error,
                    duration: 3
                });
            }
        });
    }

    // TABLE SETTING

    getColumns = () => {
        const { t } = this.props;
        return [
            {
                title: t('Category'),
                dataIndex: 'bookingCategoryName',
                key: 'bookingCategoryName',
                ...this.getColumnSearchProps('bookingCategoryName')
            },
            {
                title: t('Sub Category'),
                dataIndex: 'bookingSubCategoryName',
                key: 'bookingSubCategoryName',
                ...this.getColumnSearchProps('bookingSubCategoryName')
            },
            {
                title: t('Start Time'),
                dataIndex: 'startTime',
                key: 'startTime',
                ...this.getColumnSearchProps('startTime')
            },
            {
                title: t('End Time'),
                dataIndex: 'endTime',
                key: 'endTime',
                ...this.getColumnSearchProps('endTime')
            },
            {
                title: t('Action'),
                dataIndex: 'id',
                key: 'action',
                render: id => (
                    <span>
                        <Button onClick={() => this.updateBookingItemOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <EditIcon style={{ color: '#1890ff', fontSize: 24 }} />
                        </Button>
                        <Button onClick={() => this.deleteBookingItemOnClick(id)} type='primary' style={{ border: 'none', background: 'none', boxShadow: 'none', margin: 1, padding: 0 }}>
                            <DeleteIcon style={{ color: '#DC004E', fontSize: 24 }} />
                        </Button>
                    </span>
                ),
            },
        ]
    }

    getColumnSearchProps = dataIndex => {
        const { t } = this.props;
        return {
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        ref={node => {
                            this.searchInput = node
                        }}
                        placeholder={`${t('Search')} ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        style={{ width: 188, marginBottom: 8, display: 'block' }}
                    />
                    <Button
                        type='primary'
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon='search'
                        size='small'
                        style={{ width: 90, marginRight: 8 }}
                    >
                        {t('Search')}
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size='small' style={{ width: 90 }}>
                        {t('Reset')}
                    </Button>
                </div>
            ),
            filterIcon: filtered => (
                <Icon type='search' style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            onFilter: (value, record) =>
                record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
                if (visible) {
                    setTimeout(() => this.searchInput.select())
                }
            },
            render: text =>
                this.state.searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{ padding: 0 }}
                        searchWords={[this.state.searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : (
                    text
                ),
        };
    };

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm()
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters()
        this.setState({ searchText: '' })
    }

    render() {
        const { t } = this.props;
        const {
            bookingItems,
            bookingItemListLoading
        } = this.props.BookingItemStore;

        return (
            <React.Fragment>
                <Form layout='horizontal'>
                    <div style={{ marginBottom: 20 }}>
                        <Title level={3} style={{ width: '80%', position: 'relative', float: 'left' }}>{t('List')}</Title>
                        <div style={{ textAlign: 'right' }}>
                            <button type='button' style={{ border: 'none', background: 'none', cursor: 'pointer' }} onClick={this.createBookingItemOnClick}>
                                <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                            </button>
                        </div>
                    </div>
                    <Spin spinning={bookingItemListLoading}>
                        <Table columns={this.getColumns()} dataSource={bookingItems} />
                    </Spin>
                </Form>
            </React.Fragment>
        )
    }
}

export default withTranslation(undefined, { i18n: adminI18n })(BookingItemListPage);
